/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extra_Session_Error_GenericInputs */

const fr_extra_session_error_generic = /** @type {(inputs: Extra_Session_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible d'ouvrir le paiement, réessaie plus tard.`)
};

/**

* @param {Extra_Session_Error_GenericInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const extra_session_error_generic = /** @type {((inputs?: Extra_Session_Error_GenericInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extra_Session_Error_GenericInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_extra_session_error_generic(inputs)
});